import { sumBy } from "lodash";

import {
  type WeekData,
  WeekStatus,
} from "../components/performance-tracking-table";

export function calculateAverageSpendOnCompletedWeeks(weekData: WeekData[]) {
  const completedWeeks = weekData.filter(
    (data) => data.status === WeekStatus.COMPLETE,
  );
  return completedWeeks.length > 0
    ? sumBy(completedWeeks, (data) => data.actual ?? 0) / completedWeeks.length
    : 0;
}
